import React from 'react';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
import type { VideoProps } from 'Components/frameworks/video/Video';
import { Video } from 'Components/frameworks/video/Video';
type Props = VideoProps & {
  id?: string;
};
export function VideoLine({ id, ...props }: Props) {
  return (
    <SiteContainer className="Line" id={id}>
      <Video {...props} />
    </SiteContainer>
  );
}
